export const licenseCategories = {
    AUTOMOVIL: ["B1", "B2", "B3", "C1", "C2", "C3"],
    MOTOCICLETA: ["A1", "A2"],
    CAMION: ["B2", "B3", "C2", "C3"],
    CAMIONETA: ["B1", "B2", "B3", "C1", "C2", "C3"],
    TRACTOCAMION: ["C3"],
    VOLQUETA: ["B2", "B3", "C2", "C3"],
    MOTOCARRO: ["B1","B2","B3","C1","C2","C3"],
};
